import { ContentTypes } from '@invoice-simple/common';

import { IsIdentifyPayload } from 'src/types/IsEvents';
import Rollbar from './rollbar';

const describeStatus = (status: number, statusText: string) =>
  statusText ? `${status} ${statusText}` : `${status}`;

export default async function identify(visitor: IsIdentifyPayload): Promise<void> {
  // userId is undefined on the login screen, don't send a request in this scenario since Amplitude will not accept it anyway
  if (!visitor.userId) return;

  const url = '/analytics/identify';
  let responseDetails: { responseStatus: number; responseContentType: string | null } | undefined;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': ContentTypes.APP_JSON
      },
      body: JSON.stringify(visitor)
    });

    if (res.status >= 400) {
      responseDetails = {
        responseStatus: res.status,
        responseContentType: res.headers.get('content-type')
      };
      throw new Error(`Failed to identify user (${describeStatus(res.status, res.statusText)})`);
    }
  } catch (err) {
    Rollbar.trackError('is-identify', err, { ...visitor, ...responseDetails });
  }
}
